import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('SystemMaintenanceService', SystemMaintenanceService);

  SystemMaintenanceService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'ModalWindowConfirmService',
  ];

  function SystemMaintenanceService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    ModalWindowConfirmService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'system_maintenance';

    var service = {
      updateMasterAccountDatabase: updateMasterAccountDatabase,
      updateCountriesForMasterAccount: updateCountriesForMasterAccount,

      updateCountriesForAllAccounts: updateCountriesForAllAccounts,
      updateCountriesForOneAccount: updateCountriesForOneAccount,
      updateAccountSettingsForAllAccounts: updateAccountSettingsForAllAccounts,
      updateAccountSettingsForOneAccount: updateAccountSettingsForOneAccount,
      updateRolesActionsForAllAccounts: updateRolesActionsForAllAccounts,
      updateRolesActionsForOneAccount: updateRolesActionsForOneAccount,
      updateCompanySettingsForOneAccount: updateCompanySettingsForOneAccount,
    };

    return service;

    ////////////////

    // Update master account database
    function updateMasterAccountDatabase(successCallback) {
      var modalParams = {
        title: 'UPDATE_MASTER_ACCOUNT_DATABASE',
        body: 'UPDATE_MASTER_ACCOUNT_DATABASE_WARNING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('DATABASE_UPDATED'));

          return successCallback;
        }

        function failure() {
          utils._errorMsg($translate('DB_UPDATING_ERROR'));

          return false;
        }

        var url = apiUrl + '/update_master_account_database';

        return RestResource.request('put', url, {}, success, failure);
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    // Update countries in database for master account
    function updateCountriesForMasterAccount(successCallback) {
      var modalParams = {
        title: 'UPDATE_COUNTRIES_FOR_MASTER_ACCOUNT',
        body: 'UPDATE_COUNTRIES_FOR_MASTER_ACCOUNT_WARNING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('DATABASE_UPDATED'));

          return successCallback;
        }
        function failure() {
          utils._errorMsg($translate('DB_UPDATING_ERROR'));

          return false;
        }

        var url = apiUrl + '/update_countries_for_master_account';

        return RestResource.request('put', url, {}, success, failure);
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    // Update countries in database for all accounts
    function updateCountriesForAllAccounts(successCallback) {
      var modalParams = {
        title: 'UPDATE_COUNTRIES_FOR_ALL_ACCOUNTS',
        body: 'UPDATE_COUNTRIES_FOR_ALL_ACCOUNTS_WARNING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('DATABASE_UPDATED'));

          return successCallback;
        }
        function failure() {
          utils._errorMsg($translate('DB_UPDATING_ERROR'));

          return false;
        }

        var url = apiUrl + '/update_countries_for_all_accounts';

        return RestResource.request('put', url, {}, success, failure);
      };

      // Use an own modal to se the loader working, as the window modal confirm doesn not work with this

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    // Update countries in database for one account
    function updateCountriesForOneAccount(account, successCallback) {
      var modalParams = {
        title: 'UPDATE_COUNTRIES',
        itemName: account.account_name,
        body: 'UPDATE_COUNTRIES_FOR_THIS_ACCOUNT_WARNING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('DATABASE_UPDATED'));

          return successCallback;
        }
        function failure() {
          utils._errorMsg($translate('DB_UPDATING_ERROR'));

          return false;
        }

        var url = apiUrl + '/update_countries_for_one_account';

        return RestResource.request(
          'put',
          url,
          { subdomain: account.subdomain, account_id: account.id },
          success,
          failure
        );
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    // Update company settings in database for one account
    function updateCompanySettingsForOneAccount(account, companies, successCallback) {
      var modalParams = {
        title: 'UPDATE_COMPANY_SETTINGS',
        itemName: account.account_name,
        body: 'UPDATE_COMPANY_SETTINGS_FOR_THIS_ACCOUNT_WARNING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('DATABASE_UPDATED'));

          return successCallback;
        }
        function failure() {
          utils._errorMsg($translate('DB_UPDATING_ERROR'));

          return false;
        }

        var url = apiUrl + '/update_company_settings_for_one_account';

        var data = {
          subdomain: account.subdomain,
          account_id: account.id,
          companies: companies,
        };

        return RestResource.request('put', url, data, success, failure);
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    // Update account settings in database for all accounts
    function updateAccountSettingsForAllAccounts(successCallback) {
      var modalParams = {
        title: 'UPDATE_ACCOUNT_SETTINGS_FOR_ALL_ACCOUNTS',
        body: 'UPDATE_ACCOUNT_SETTINGS_FOR_ALL_ACCOUNTS_WARNING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('DATABASE_UPDATED'));

          return successCallback;
        }
        function failure() {
          utils._errorMsg($translate('DB_UPDATING_ERROR'));

          return false;
        }

        var url = apiUrl + '/update_account_settings_for_all_accounts';

        return RestResource.request('put', url, {}, success, failure);
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    // Update account settings in database for one account
    function updateAccountSettingsForOneAccount(account, successCallback) {
      var modalParams = {
        title: 'UPDATE_ACCOUNT_SETTINGS',
        itemName: account.account_name,
        body: 'UPDATE_ACCOUNT_SETTINGS_FOR_THIS_ACCOUNT_WARNING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('DATABASE_UPDATED'));

          return successCallback;
        }
        function failure() {
          utils._errorMsg($translate('DB_UPDATING_ERROR'));

          return false;
        }

        var url = apiUrl + '/update_account_settings_for_one_account';

        return RestResource.request(
          'put',
          url,
          { subdomain: account.subdomain, account_id: account.id },
          success,
          failure
        );
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    // Update roles actions for all accounts
    function updateRolesActionsForAllAccounts(successCallback) {
      var modalParams = {
        title: 'UPDATE_ROLES_ACTIONS_FOR_ALL_ACCOUNTS',
        body: 'UPDATE_ROLES_ACTIONS_FOR_ALL_ACCOUNTS_WARNING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('DATABASE_UPDATED'));

          return successCallback;
        }
        function failure() {
          utils._errorMsg($translate('DB_UPDATING_ERROR'));

          return false;
        }

        var url = apiUrl + '/update_roles_actions_for_all_accounts';

        return RestResource.request('put', url, {}, success, failure);
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }

    // Update roles actions for one account
    function updateRolesActionsForOneAccount(account, successCallback) {
      var modalParams = {
        title: 'UPDATE_ROLES_ACTIONS',
        itemName: account.account_name,
        body: 'UPDATE_ROLES_ACTIONS_FOR_THIS_ACCOUNT_WARNING',
      };

      var confirmCallback = function () {
        function success() {
          utils._successMsg($translate('DATABASE_UPDATED'));

          return successCallback;
        }
        function failure() {
          utils._errorMsg($translate('DB_UPDATING_ERROR'));

          return false;
        }

        var url = apiUrl + '/update_roles_actions_for_one_account';

        return RestResource.request(
          'put',
          url,
          { subdomain: account.subdomain, account_id: account.id },
          success,
          failure
        );
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback);
    }
  }
})();
